import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  UPLOAD_ATTACHMENT_LOG_URL,
  GET_ATTACHMENT_LOG_LIST_URL,
  DELETE_ATTACHMENT_LOG_BY_ID_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../comman/CustomFunction";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";
import { getUploadErrorMessage, uploadAttachmentFiles } from "./attachmentUpload";
import CustomLoader from "../comman/CustomLoader";
import {
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  UploadDeleteIcon,
} from "../../images/SvgIcons";
import { useNavigate, useParams } from "react-router";
import { ADMIN_BILLING_LIST, BILLING_STATEMENT_LIST_ROUTE } from "../../constants/RoutePath";
import * as types from "../../redux/action/ActionType";
import { useDispatch } from "react-redux";
import { downloadAllAttachments } from "../../utils/attachmentUtils";

const moment = require("moment");

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function BillingAttachment(props) {
  const {
    open,
    handleClose,
    billingStatementDetail,
    billingId,
    activeStep,
    IsorphanedPage,
  } = props;
  console.log(billingId, "jjjjjjjjjj", billingStatementDetail);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showToast = useToast();
  const { bid } = useParams();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [attachmentFile, setAttachmentFile] = React.useState([]);
  const [attachmentName, setAttachmentName] = React.useState([]);
  const [attachmentRemark, setAttachmentRemark] = React.useState("");
  const [attachmentFileObject, setAttachmentFileObject] = React.useState([]);
  const [updateCancelButton, setUpdateCancelButton] = React.useState(false);
  const [disabledEditDelete, setDisabledEditDelete] = React.useState(0);
  const [, setAttachementFilePath] = React.useState("");
  console.log(disabledEditDelete, "attachmentFilePathattachmentFilePath");
  const [loading, setLoading] = React.useState(false);
  const [attachmentLoading, setAttachemntLoading] = React.useState(false);
  const [deleteDoublevalidation, setDeleteDoubleValidation] =
    React.useState(false);
  const [selectedAttachmentId, setSelectedAttachmentId] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  console.log(downloadLoading, "aaaaaaaaaaaa");
  console.log(attachmentFile, "billingStatementDetail", attachmentName);
  console.log("idididididididid", bid, useParams());
  // const downLoadAttachment = async () => {
  //   for (let i = 0; i < attachmentFileObject.length; i++) {
  //     const path = attachmentFileObject[i].Path;
  //     setTimeout(() => {
  //       const anchor = document.createElement("a");
  //       anchor.href = path;
  //       anchor.download = path.split("/").pop();
  //       document.body.appendChild(anchor);
  //       anchor.click();
  //       document.body.removeChild(anchor);
  //     }, i * 2000);
  //   }
  // };

  const photos = [
    {
      name: "photo_01.jpeg",
      url: "https://images.pexels.com/photos/104827/cat-pet-animal-domestic-104827.jpeg",
    },
    {
      name: "photo_02.jpeg",
      url: "https://images.pexels.com/photos/57416/cat-sweet-kitty-animals-57416.jpeg",
    },
  ];

  const photos1 = [
    {
      attachmentId: 91,
      ParentTypeID: 1,
      ProjID: 5072,
      PeriodKey: "1110202420102024",
      FileName: "photo_01[1].jpeg",
      Description: "test",
      Path: "https://hosv2dev.blob.core.windows.net/hosv2dev/photo_011_2024-08-07-12-10-54.jpeg",
      // "Path": "https://images.pexels.com/photos/104827/cat-pet-animal-domestic-104827.jpeg",
      UploadDate: "2024-08-07T00:00:00.000Z",
      UserName: "Suganthan SAB",
    },
    {
      attachmentId: 92,
      ParentTypeID: 1,
      ProjID: 5072,
      PeriodKey: "1110202420102024",
      FileName: "photo_02[1].jpeg",
      Description: "test",
      Path: "https://hosv2dev.blob.core.windows.net/hosv2dev/photo_021_2024-08-07-12-17-18.jpeg",
      // "Path": "https://images.pexels.com/photos/57416/cat-sweet-kitty-animals-57416.jpeg",
      UploadDate: "2024-08-07T00:00:00.000Z",
      UserName: "Suganthan SAB",
    },
  ];

  const formatDate = (date) => {
    const [month, day, year] = date.split("/"); // Split date by "/"
    return `${month}${day}${year}`; // Concatenate as MMDDYYYY
  };

  const expectedFormat =
    formatDate(billingStatementDetail.hStartDate) +
    formatDate(billingStatementDetail.hEndDate);

  console.log(expectedFormat);

  // const downLoadAttachment = async () => {
  //   setDownloadLoading(true);
  //   const zip = new JSZip();

  //   try {
  //     // Fetch images and add them to the zip
  //     const fetchPromises = attachmentFileObject.map(async (photo, index) => {
  //       setDownloadLoading(true);
  //       try {
  //         const response = await fetch(photo.Path);
  //         if (!response.ok) {
  //           throw new Error(
  //             `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
  //           );
  //         }

  //         const blob = await response.blob();
  //         const fileName = photo.FileName;

  //         // Create a folder for each duplicate file to avoid renaming
  //         const folderName = `file_${index + 1}`; // Folder names can be unique (like `file_1`, `file_2`, etc.)
  //         const folder = zip.folder(fileName);
  //         console.log(folder.file(fileName, blob), 'follllllllllllllllllll',folderName)
  //         // Add the file to the folder with the original file name
  //         folder.file(fileName, blob);
  //       } catch (error) {
  //         console.error(`Error fetching ${photo.Path}:`, error);
  //       }
  //     });

  //     // Wait for all fetch promises to resolve
  //     await Promise.all(fetchPromises);

  //     // Generate the zip file and save it
  //     const zipBlob = await zip.generateAsync({ type: "blob" });
  //     saveAs(
  //       zipBlob,
  //       `${billingStatementDetail.hbokerName}_${billingStatementDetail.hProjectName}_${expectedFormat}.zip`
  //     );
  //   } catch (error) {
  //     console.error("Error generating or saving zip file:", error);
  //   } finally {
  //     setDownloadLoading(false);
  //   }
  // };

  // const downLoadAttachment = async () => {
  //   setDownloadLoading(true);
  //   const zip = new JSZip();

  //   try {
  //     // Fetch images and add them to the zip
  //     const fetchPromises = attachmentFileObject.map(async (photo, index) => {
  //       setDownloadLoading(true);
  //       try {
  //         const response = await fetch(photo.Path);
  //         if (!response.ok) {
  //           throw new Error(
  //             `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
  //           );
  //         }

  //         const blob = await response.blob();
  //         const fileName = photo.FileName; // Use the original filename

  //         // Create a unique folder for each file to allow duplicates
  //         const folder = zip.folder(`file_${index}`); // Unique folder name for each file
  //         folder.file(fileName, blob); // Add file to its unique folder with the original name

  //       } catch (error) {
  //         console.error(`Error fetching ${photo.Path}:`, error);
  //       }
  //     });

  //     // Wait for all fetch promises to resolve
  //     await Promise.all(fetchPromises);

  //     // Generate the zip file and save it
  //     const zipBlob = await zip.generateAsync({ type: "blob" });
  //     saveAs(
  //       zipBlob,
  //       `${billingStatementDetail.hbokerName}_${billingStatementDetail.hProjectName}_${expectedFormat}.zip`
  //     );
  //   } catch (error) {
  //     console.error("Error generating or saving zip file:", error);
  //   } finally {
  //     setDownloadLoading(false);
  //   }
  // };

  const downLoadAttachment = async () => {
    setDownloadLoading(true);
    try {
      await downloadAllAttachments({
        attachments: attachmentFileObject,
        zipName: `${billingStatementDetail.hProjectName}_attachments_${expectedFormat}`,
      });
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      setDownloadLoading(false);
    }
  };

  // const downLoadAttachment = async () => {
  //   const zip = new JSZip();
  //   const folder = zip.folder();
  //   //Add images to folder
  //   photos1.forEach((photo) => {
  //     console.log(photo,'jxxxxxxxxxxx')
  //     const blob = fetch(photo.Path).then((res) => res.blob());
  //     console.log(blob,'jxxxxxxxxxxx',fetch(photo.Path).then((res) => res.blob()))
  //     folder.file(photo.FileName, blob, { binary: true });
  //   });

  //   //Zip folder and download folderZip
  //   zip.generateAsync({ type: "blob" }).then((blob) => {
  //     saveAs(blob, "ZipFiles");
  //   });
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (files.length === 0) return;

    const filenames = files.map((file) => {
      let filename = file.name;
      const maxLength = 100;
      const lastDotIndex = filename.lastIndexOf(".");
      const extension = lastDotIndex !== -1 ? filename.substring(lastDotIndex) : "";
      if (filename.length > maxLength) {
        filename = `${filename.substring(0, maxLength - extension.length - 3)}...${extension}`;
      }
      return filename;
    });
    setAttachmentName((previousNames) => [...previousNames, ...filenames]);
    setAttachmentFile((previousFiles) => [...previousFiles, ...files]);
    e.target.value = null;
  };

  const removePendingFile = (index) => {
    setAttachmentFile((files) => files.filter((_, fileIndex) => fileIndex !== index));
    setAttachmentName((names) => names.filter((_, fileIndex) => fileIndex !== index));
  };

  const handleRemarkChange = (event) => {
    setAttachmentRemark(event.target.value);
  };
  const updateDescriptionApi = async () => {
    let postObj = {
      parentID: 0,
      ParentTypeID: 1,
      projID: billingStatementDetail.hprojectID,
      userID: IsorphanedPage == "orphanedPage" ? getLogUserId() : billingStatementDetail.huserId,
      periodKey: billingStatementDetail.hperiodKey,
      fileName: attachmentName.join(","),
      description: attachmentRemark,
      path: response.data.filepath,
      isOrphaned: IsorphanedPage == "orphanedPage" ? 1 : 0,
    };

    const config = {
      method: "POST",
      url: UPLOAD_ATTACHMENT_LOG_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setCustomerName(values.name);
        showToast("Attachment uploaded successfully", "success");
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        }else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        }else {
          showToast(v?.message, "error");
        }
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async () => {
    if (!attachmentRemark) {
      showToast(
        "Cannot save file attachment. Attachment description is required.",
        "error"
      );
      return false;
    }

    if (attachmentFile.length === 0) {
      showToast(
        "Cannot save file attachment. Attachment file is required.",
        "error"
      );
      return false;
    }
    setLoading(true);
    let uploadedFiles;
    try {
      uploadedFiles = await uploadAttachmentFiles(attachmentFile);
    } catch (error) {
      // Keep the selected files so the user can retry.
      showToast(getUploadErrorMessage(error), "error");
      setLoading(false);
      return false;
    }

    const handleAccessDenied = (v) => {
      showToast(v?.message?.message, "error");
      if (v?.message?.accessDenied == 1) {
        dispatch({
          type: types.BILLING_STATEMENT_SELECT,
          payload: {
            customerStatus: "",
            projectStatus: "",
            projectId: "",
            userId: "",
            filterValues: {},
          },
        });
        dispatch({
          type: types.ADMIN_BILLING_STATEMENT_SELECT,
          payload: {
            customerStatus: "",
            projectStatus: "",
            userId: "",
            projectId: "",
            filterValues: {},
          },
        });
      }
      if(IsorphanedPage == "orphanedPage"){
        navigate(ADMIN_BILLING_LIST);
      }else{
        navigate(BILLING_STATEMENT_LIST_ROUTE);
      }
    };

    // One attachment record is saved per uploaded file.
    let postObj = {
      attachmentId: 0,
      parentID: bid ? bid : billingId,
      ParentTypeID: 1,
      projID: billingStatementDetail.hprojectID,
      userID: IsorphanedPage == "orphanedPage" ? getLogUserId() : billingStatementDetail.huserId,
      periodKey: billingStatementDetail.hperiodKey,
      description: attachmentRemark,
      files: uploadedFiles,
      isOrphaned: IsorphanedPage == "orphanedPage" ? 1 : 0,
    };

    const config = {
      method: "POST",
      url: UPLOAD_ATTACHMENT_LOG_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        showToast(
          uploadedFiles.length > 1
            ? `${uploadedFiles.length} attachments uploaded successfully`
            : "Attachment uploaded successfully",
          "success"
        );
        setAttachmentFile([]);
        setAttachmentName([]);
        setAttachmentRemark("");
        const descriptionInput = document.getElementById("outlined-multiline-static");
        if (descriptionInput) descriptionInput.value = "";
      } else {
        showToast(parsedResponse.message || "Unable to save attachments.", "error");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1 || v?.message?.accessDenied == 2) {
          handleAccessDenied(v);
        } else {
          showToast(v?.message?.message || v?.message, "error");
        }
      } else {
        showToast("Unable to save attachments.", "error");
      }
    } finally {
      getAttachmentListByProjectId();
      setLoading(false);
    }
  };
  const handleFileUpdate = async () => {
    setLoading(true);
    if (!attachmentRemark) {
      showToast(
        "Cannot save file attachment. Attachment description is required.",
        "error"
      );
      return false;
    }
    var formData = new FormData();
    let postObj = {
      attachmentId: disabledEditDelete, //update
      parentID: bid ? bid : billingId,
      ParentTypeID: 1,
      projID: billingStatementDetail.hprojectID,
      userID: IsorphanedPage == "orphanedPage" ? getLogUserId() : billingStatementDetail.huserId,
      periodKey: billingStatementDetail.hperiodKey,
      // Edits rename one attachment; the file itself is not replaced.
      fileName: attachmentName[0] ?? "",
      description: attachmentRemark,
      isOrphaned: IsorphanedPage == "orphanedPage" ? 1 : 0,
    };
    const config = {
      method: "POST",
      url: UPLOAD_ATTACHMENT_LOG_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // setCustomerName(values.name);
        showToast("Description updated successfully", "success");
        getAttachmentListByProjectId();
        setAttachmentRemark("");
        setAttachementFilePath("");
        setUpdateCancelButton(false);
        setDisabledEditDelete(0);
      setAttachmentName([]);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        }else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        } else {
          showToast(v?.message, "error");
        }
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const attachmentRemoveFunction = (value) => {
    setSelectedAttachmentId(value);
    setDeleteDoubleValidation(true);
    // const updatedAttachmentFileObject = attachmentFileObject.filter(
    //   (item) => item.attachmentId !== value
    // );
    // setAttachmentFileObject(updatedAttachmentFileObject);

    // deleteAttachmentById(value);
  };

  const handleYesClick = () => {
    if (selectedAttachmentId === null) return; // Safety check

    const updatedAttachmentFileObject = attachmentFileObject.filter(
      (item) => item.attachmentId !== selectedAttachmentId
    );
    setAttachmentFileObject(updatedAttachmentFileObject);
    deleteAttachmentById(selectedAttachmentId);
    setSelectedAttachmentId(null);
    setDeleteDoubleValidation(false);
  };

  const handleNoClick = () => {
    // Close the dialog without any action
    setSelectedAttachmentId(null);
    setDeleteDoubleValidation(false);
  };

  /*
  const handleFileUploadLog = async () => {

    let successFlagCount = 0;

    for (const item of attachmentFileObject) {


      let postObj = {
        "parentID": item.parentID,
        "ParentTypeID": item.ParentTypeID,
        "projID": item.projID,
        "userID": item.userID ? Number(item.userID) : 0,
        "periodKey": item.periodKey,
        "fileName": item.fileName,
        "description": item.description,
        "path": item.path
      }

      const config = {
        method: "POST",
        url: UPLOAD_ATTACHMENT_LOG_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(postObj)),
          flutterString: "",
        },
      };

      try {
        const response =await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          successFlagCount = successFlagCount+1
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
        }
      }
      
    }

    if(successFlagCount == attachmentFileObject.length){
     showToast
        "Attachment log added successfully",
        "success",
        enqueueSnackbar
      );
    }

    handleClose(false)

  }


*/

  useEffect(() => {}, [bid]);
  const getAttachmentListByProjectId = async () => {
    setAttachemntLoading(true);
    const config = {
      method: "GET",
      url: GET_ATTACHMENT_LOG_LIST_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({
            // projectId: billingStatementDetail.hprojectID,
            // type: 1,
            // periodKey: billingStatementDetail.hperiodKey,
            userId: billingStatementDetail.huserId,
            billingStatementId: bid ? bid : billingId,
            parentTypeId: 1 
          })
        ),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("parse", parsedResponse);

      if (parsedResponse.status == "Success") {
        setAttachmentFileObject(parsedResponse.data);
      }
      setAttachemntLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        //showToast(v.message, "error");
      }
      setAttachemntLoading(false);
    }
  };

  const deleteAttachmentById = async (attachmentId) => {
    const config = {
      method: "DELETE",
      url: DELETE_ATTACHMENT_LOG_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({ attachmentId: attachmentId, isOrphaned: IsorphanedPage == "orphanedPage" ? 1 : 0 })
        ),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast("Attachment removed successfully", "success");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        }else if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          if(IsorphanedPage == "orphanedPage"){
            navigate(ADMIN_BILLING_LIST);
          }else{
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          }
        } else {
          showToast(v?.message, "error");
        }
      }
    }
  };

  useEffect(() => {
    if (billingStatementDetail.hprojectID) {
      getAttachmentListByProjectId();
    }
  }, [1]);

  const handleDescriptionEdit = (description, id, filepath, FileName) => {
    // const filterDisable = attachmentFileObject?.filter((item)=> item.attachmentId === id)
    setAttachmentRemark(description);
    setUpdateCancelButton(true);
    setDisabledEditDelete(id);
    setAttachementFilePath(filepath);
    setAttachmentName(FileName ? [FileName] : []);
  };

  const handleDescCancelButton = () => {
    setUpdateCancelButton(false);
    setAttachmentRemark("");
    setDisabledEditDelete(0);
    setAttachmentName([]);
    setAttachementFilePath("");
  };

  const handleUpdateDescription = () => {
    handleFileUpdate();
  };

  return (
    <React.Fragment>
      <Dialog
        className="billing-attachment-filter"
        fullScreen={fullScreen}
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "16px 20px", borderBottom: "1px solid #EDEDED" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          {attachmentFileObject && attachmentFileObject.length > 0 ? (
            <Typography className="attachment-title">
              <span className="attachment-num">
                {attachmentFileObject.length}
              </span>{" "}
              attachments found
            </Typography>
          ) : (
            <Typography>
              <p className="billing-upload-title">
                No attachments found. Click the button below to upload
                attachments to this billing statement.
              </p>
            </Typography>
          )}

          {!downloadLoading &&
          attachmentFileObject &&
          attachmentFileObject?.length > 0 ? (
            <Tooltip
              className="project-tooltip"
              title="Download all attachments."
              placement="top"
            >
              <Button
                class="download-btn-billing"
                style={{ cursor: "pointer" }}
                startIcon={<DownloadIcon />}
                onClick={downLoadAttachment}
              ></Button>
            </Tooltip>
          ) : (
            // <span
            //   class="material-symbols-outlined download-btn"
            //   style={{ cursor: "pointer" }}
            //   title="download all attachments"
            //   onClick={downLoadAttachment}
            // >
            //   download
            // </span>
            // </Tooltip>
            <Box class="download-btn-disable">
              <DownloadIcon
                style={{ background: "#d5d5d6 !important", important: "true" }}
              />
            </Box>
            // <span
            //   class="material-symbols-outlined download-btn"
            //   style={{ background: "#c5c5c5 !important", important: "true" }}
            // >
            //   download
            // </span>
          )}
        </Stack>
        <DialogContent sx={{ pt: 0, pb: 0 }}>
          <Grid sx={{ height: "100%" }} container spacing={2}>
            <Grid
              sx={{
                borderRight: "1px solid #EDEDED",
              }}
              item
              xs={12}
              md={6}
            >
              <Box sx={{ padding: "20px 32px 20px 0px!important" }}>
                <Typography className="upload-title">
                  Upload New Attachment
                </Typography>
                <Stack
                  sx={{ mt: "19px" }}
                  direction="column"
                  spacing={1.5}
                  alignItems="flex-start"
                >
                  <Button
                    className={
                      billingStatementDetail?.hStatus !== "Statement Open" ||
                      activeStep != 0 ||
                      loading ||
                      disabledEditDelete != 0
                        ? "disable-choose-file"
                        : "choose-file-btn"
                    }
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    disabled={
                      billingStatementDetail?.hStatus !== "Statement Open" ||
                      activeStep != 0 ||
                      disabledEditDelete != 0 ||
                      loading
                    }
                  >
                    Choose Files
                    <VisuallyHiddenInput
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      type="file"
                      multiple
                    />
                  </Button>
                  {attachmentName.length > 0 && (
                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 1, width: "100%" }}>
                      {attachmentName.map((filename, index) => (
                        <Chip
                          key={`${filename}-${index}`}
                          className="up-filename"
                          label={filename}
                          disabled={loading || updateCancelButton}
                          deleteIcon={<CancelIcon />}
                          onDelete={() => removePendingFile(index)}
                          sx={{ maxWidth: "100%" }}
                        />
                      ))}
                    </Box>
                  )}
                </Stack>
                <TextField
                  className="upload-textarea"
                  sx={{
                    width: "-webkit-fill-available",
                    marginTop: "8px",
                  }}
                  id="outlined-multiline-static"
                  multiline
                  rows={7}
                  defaultValue=""
                  value={attachmentRemark}
                  disabled={
                    loading ||
                    billingStatementDetail?.hStatus !== "Statement Open" ||
                    (activeStep != 0 && !updateCancelButton) ||
                    (attachmentName.length === 0 && attachmentRemark == "")
                  }
                  placeholder="Write Description"
                  onChange={handleRemarkChange}
                />
                {!updateCancelButton && (
                  <Box>
                    <Button
                      className={
                        attachmentFile.length === 0 || loading
                          ? "upload-disable-file-btn"
                          : "upload-file-btn"
                      }
                      onClick={handleFileUpload}
                      variant="contained"
                      disabled={attachmentFile.length === 0 || loading}
                    >
                      {loading && (
                        <CircularProgress
                          color={"inherit"}
                          size={10}
                          sx={{ marginRight: "3px" }}
                        />
                      )}
                      Upload Files
                    </Button>
                  </Box>
                )}
                {updateCancelButton && (
                  <Stack sx={{ mt: "11px" }} spacing={2} direction="row">
                    <Button
                      className="primary-btn"
                      variant="contained"
                      onClick={handleUpdateDescription}
                    >
                      {loading && (
                        <CircularProgress
                          color={"inherit"}
                          size={10}
                          sx={{ marginRight: "3px" }}
                        />
                      )}
                      Update
                    </Button>
                    <Button
                      className="cancel-btn"
                      variant="contained"
                      onClick={handleDescCancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                )}
              </Box>
            </Grid>
            <Grid
              sx={{ padding: "20px 0px", pl: "21px !important" }}
              item
              xs={12}
              md={6}
            >
              {attachmentLoading ||
                (loading && (
                  <Box
                    sx={{
                      background: "#fff",
                      padding: "25px 24px",
                      mt: "15px",
                    }}
                    className="secound-bg-box user-log"
                  >
                    <Grid container>
                      <Grid xs={12} md={12} colSpan={7} align="center">
                        <CircularProgress disableShrink />
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              {!attachmentLoading &&
              attachmentFileObject &&
              attachmentFileObject?.length > 0 ? (
                <Box
                  sx={{
                    padding: "20px 0px !important",
                    paddingBottom: "10px !important",
                    maxHeight: "290px",
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  {!attachmentLoading &&
                    attachmentFileObject.map(function (item, i) {
                      console.log(item, "itemmmmmmm");
                      return (
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="flex-start"
                          justifyContent="space-between"
                          key={i}
                          sx={{ marginBottom: "13px" }}
                        >
                          <Box sx={{ width: "100%" }}>
                            <Typography className="upload-file-name">
                              {item.FileName ? (
                                <a
                                  href={item.Path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "underline",
                                    color: "rgb(21 0 176)",
                                  }}
                                >
                                  {item.FileName}
                                </a>
                              ) : (
                                "No file selected"
                              )}
                            </Typography>

                            <Typography className="upload-file-text">
                              {item.Description
                                ? item.Description
                                : "No Remarks ..."}
                            </Typography>
                            <Stack
                              sx={{ mt: "9px" }}
                              direction="row"
                              alignItems="flex-end"
                              justifyContent="space-between"
                            >
                              <Box>
                                <Button
                                  className="upload-name-btn"
                                  variant="outlined"
                                  startIcon={
                                    <span class="material-symbols-outlined">
                                      person
                                    </span>
                                  }
                                >
                                  <span style={{ lineBreak: "anywhere" }}>
                                    {item.UserName
                                      ? item.UserName
                                      : "Unknown User"}
                                  </span>
                                </Button>
                              </Box>
                              <Typography className="upload-name-btn">
                                {item.UploadDate
                                  ? moment
                                      .utc(item.UploadDate)
                                      .format("MM/DD/YYYY")
                                  : ""}
                              </Typography>
                            </Stack>
                          </Box>
                          <Box
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <IconButton
                              className={
                                billingStatementDetail?.hStatus !==
                                  "Statement Open" ||
                                activeStep != 0 ||
                                // item?.attachmentId ===
                                disabledEditDelete
                                  ? "disable-file-edit"
                                  : "file-edit"
                              }
                              disabled={
                                billingStatementDetail?.hStatus !==
                                  "Statement Open" ||
                                activeStep != 0 ||
                                // item?.attachmentId ===
                                disabledEditDelete ||
                                updateCancelButton
                              }
                              onClick={() =>
                                handleDescriptionEdit(
                                  item.Description,
                                  item?.attachmentId,
                                  item.Path,
                                  item.FileName
                                )
                              }
                              aria-label="edit"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              className={
                                billingStatementDetail?.hStatus !==
                                  "Statement Open" ||
                                activeStep != 0 ||
                                // item?.attachmentId ===
                                disabledEditDelete
                                  ? "disable-file-delete"
                                  : "file-delete"
                              }
                              disabled={
                                billingStatementDetail?.hStatus !==
                                  "Statement Open" ||
                                activeStep != 0 ||
                                // item?.attachmentId ===
                                disabledEditDelete
                              }
                              onClick={() =>
                                attachmentRemoveFunction(item.attachmentId)
                              }
                              aria-label="delete"
                            >
                              <UploadDeleteIcon />
                            </IconButton>
                          </Box>
                        </Stack>
                      );
                    })}
                </Box>
              ) : (
                ""
              )}
              <Button
                sx={{ mt: "8px", position: "absolute", bottom: "15px" }}
                className="cancel-btn"
                variant="contained"
                onClick={handleClose}
              >
                Cancel
              </Button>
              {/* {attachmentFileObject && attachmentFileObject.length > 0 ?
              <Button className="save-btn" onClick={handleFileUploadLog} >Save</Button>
              :""} */}
            </Grid>
          </Grid>
          {deleteDoublevalidation && (
            <Dialog
              className="user-filter-popup project-filter"
              sx={{
                width: "100% !important",
                height: "100%",
                maxHeight: "fit-co",
              }}
              // fullScreen={fullScreen}
              open={open}
              //  onClose={handleChangeno}
              aria-labelledby="responsive-dialog-title"
            >
              <Stack
                sx={{ p: "25px 25px", pb: "4px" }}
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent="space-between"
              >
                <Typography className="model-title">
                  Remove Attachment
                </Typography>
              </Stack>
              <Box sx={{ p: "0px 25px 0px 25px" }}>
                <p className="label">
                  Are you sure you want to remove this attachment?
                </p>
              </Box>
              <DialogActions
                sx={{
                  justifyContent: "flex-start",
                  p: "20px 25px",
                  pt: "18px",
                }}
              >
                <Button className="filter-btn" onClick={() => handleYesClick()}>
                  Yes
                </Button>
                <Button className="cancel-btn" onClick={handleNoClick}>
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
